function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 15.71A6.21 6.21 0 1 0 9 3.29a6.21 6.21 0 0 0 0 12.42zm0 1.44a7.65 7.65 0 1 1 0-15.3 7.65 7.65 0 0 1 0 15.3zm0-6.21a1.44 1.44 0 1 0 0-2.88 1.44 1.44 0 0 0 0 2.88zm0 1.44a2.88 2.88 0 1 1 0-5.76 2.88 2.88 0 0 1 0 5.76zM7.312.5h3.375l.563 2.25h-4.5L7.313.5zm0 18l-.562-2.25h4.5l-.563 2.25H7.313zM18 7.812v3.375l-2.25.563v-4.5l2.25.563zM0 11.188V7.813l2.25-.563v4.5L0 11.187zm16.557 3.484l-2.386 2.386-1.989-1.193 3.182-3.182 1.193 1.989zM3.83 1.943l1.989 1.193-3.182 3.182-1.193-1.989 2.386-2.386zm10.342 0l2.386 2.386-1.193 1.989-3.182-3.182 1.989-1.193zM1.443 14.67l1.193-1.989 3.182 3.182-1.989 1.193-2.386-2.386z",
  fillRule: "nonzero"
});

var SvgGear = function SvgGear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Gear.b0a1eaac.svg";
export { ForwardRef as ReactComponent };